'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { usePurchasePagePersonalQuery } from '@haaretz/s-pp-queries/PurchasePage';
import usePpDataVariables from '@haaretz/s-use-pp-data-variables';
import StepComponent from './Step.component';
export default function Step({ currentStep }) {
    const variables = usePpDataVariables();
    const { data } = usePurchasePagePersonalQuery(variables, {
        enabled: false
    });
    const allSteps = data?.PurchasePage?.pageData?.allSteps;
    if (!allSteps) return null;
    return /*#__PURE__*/ _jsx(StepComponent, {
        allSteps: allSteps,
        currentStep: currentStep
    });
}

//# sourceMappingURL=Step.js.map